import axiosInstance from '../axiosInstance';

// 2days Pre-join API (404 는 화면에서 직접 처리)
const data = (res) => res.data?.data ?? res.data;

export const getJoinInfo = async (slug) =>
  data(await axiosInstance.get(`/two-days/join/${slug}`, { skipGlobalError: true }));

export const submitJoin = async (slug, body) =>
  data(await axiosInstance.post(`/two-days/join/${slug}`, body, { skipGlobalError: true }));

export const getMyCareerReports = async () =>
  data(await axiosInstance.get('/career-reports', { skipGlobalError: true }));
